import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ACircularImage',
  props: {
    image: {},
    float: { default: 'right' }
  },
  setup(__props: any) {

const props = __props

const classes = computed(() => (props.float !== 'none' ? `float-${props.float}` : ''))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(["image", classes.value]),
    style: _normalizeStyle({ backgroundImage: `url(${__props.image})` })
  }, null, 6))
}
}

})